import React, { FC, PropsWithChildren } from 'react';
import styles from './Tag.module.sass';

const Tag: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.Tag}>
      <span className={styles.Tag__content}>
        {children}
      </span>
    </div>
  )
}

export default Tag